import { MouseEvent, useCallback } from 'react';
import { useNavigate } from 'react-router';

const PRODUCTION_DOMAINS = ['app.maletadoengenheiro.com.br', 'app.coordly.com.br'];

/** Abre pelo router os links da própria aplicação presentes nas respostas da IA. */
export const useInternalLinkHandler = () => {
  const navigate = useNavigate();

  return useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      const href = event.currentTarget.getAttribute('href');
      if (!href) return;

      try {
        const url = new URL(href);
        const isInternal =
          PRODUCTION_DOMAINS.some((domain) => url.hostname.includes(domain)) ||
          url.hostname === window.location.hostname;

        if (!isInternal) return;

        event.preventDefault();
        const redirectUrl = url.searchParams.get('redirectUrl');
        navigate(
          redirectUrl
            ? decodeURIComponent(redirectUrl)
            : url.pathname + url.search + url.hash
        );
      } catch {
        if (href.startsWith('/')) {
          event.preventDefault();
          navigate(href);
        }
      }
    },
    [navigate]
  );
};
